export default {
    meta: {
        title: '踩点记录',
        url: '/spotsurvey/create',
        urlName: '踩点记录',
    }
};
